import { useAccountFlow } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { AccountHeader } from './accountHeader';
import { AccountProgress } from './accountProgress';
import { AccountDetails } from './accountDetails';

interface AccountCardTileProps {
  className?: string;
  account: AccountResponse;
  noHover?: boolean;
}

export const AccountCardTile = (props: AccountCardTileProps) => {
  const accountFlow = useAccountFlow(props.account.id);

  if (accountFlow?.view === false) return null;
  return (
    <section
      className={cn(
        'flex flex-col bg-white transition-shadow duration-200 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'overflow-hidden rounded-xl dark:border dark:border-gray-black',
        !props.noHover && 'hover:shadow-lg dark:hover:shadow-lg-dark',
        props.className,
      )}
    >
      <AccountHeader account={props.account} />
      <div className='flex flex-col gap-3 px-5 py-4'>
        <AccountProgress account={props.account} />
        <hr className='text-gray-black' />
        <AccountDetails account={props.account} />
      </div>
    </section>
  );
};
